import { isValidEmail } from '@akrababul/shared';
import { qs } from '../lib/dom.js';
import { authClient } from '../lib/auth-client.js';
import { redirectIfLoggedIn } from '../lib/session-guard.js';
import { captchaToken, resetCaptcha } from '../lib/captcha.js';
import { loginErrorMessage } from '../lib/auth-errors.js';
import { showInAppBrowserWarning } from '../lib/in-app-browser.js';

const nextParam = new URLSearchParams(location.search).get('next');
void redirectIfLoggedIn(nextParam && nextParam.startsWith('/') && !nextParam.startsWith('//') ? nextParam : '/akrabalarim.html');
showInAppBrowserWarning(qs('#browser-uyari'));

const err = qs('#err'); const show = (m: string) => { err.textContent = m; err.classList.remove('hidden'); };
{
  const q = new URLSearchParams(location.search); const n = qs('#notice');
  if (q.get('reset') === '1') { n.textContent = 'Şifreniz güncellendi. Yeni şifrenizle giriş yapabilirsiniz.'; n.classList.remove('hidden'); }
  if (q.get('silindi') === '1') { n.textContent = 'Hesabınız silindi. Dilerseniz yeniden kayıt olabilirsiniz.'; n.classList.remove('hidden'); }
}

qs<HTMLFormElement>('#f').addEventListener('submit', async (e) => {
  e.preventDefault(); err.classList.add('hidden');
  const email = qs<HTMLInputElement>('#email').value.trim();
  if (!isValidEmail(email)) return show('Geçerli bir e-posta adresi yazın.');
  const token = captchaToken(); if (!token) return show('Lütfen robot olmadığınızı doğrulayın.');
  const { error } = await authClient.signIn.email({
    email, password: qs<HTMLInputElement>('#pw').value,
    fetchOptions: { headers: { 'x-captcha-response': token } },
  });
  if (error) {
    resetCaptcha();
    return show(loginErrorMessage(error.status ?? 0, error.message ?? ''));
  }
  const next = new URLSearchParams(location.search).get('next');
  window.location.href = next && next.startsWith('/') && !next.startsWith('//') ? next : '/akrabalarim.html';
});
qs('#google').addEventListener('click', () => authClient.signIn.social({ provider: 'google', callbackURL: '/akrabalarim.html' }));
